export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.notices': '系统公告',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.workplace': '工作台',
  'menu.monitor-alert': '监控告警',
  'menu.monitor-alert.monitor': '实时监控',
  'menu.monitor-alert.warning-info': '预警信息',
  'menu.monitor-alert.push-config': '推送配置',
  'menu.algorithm-center': '算法中心',
  'menu.algorithm-center.algorithm-market': '算法商城',
  'menu.algorithm-center.my-algorithm': '我的算法',
  'menu.algorithm-center.algo-self-train': '算法自训练',
  'menu.algorithm-center.algo-self-train-review': '样本复核',
  'menu.algorithm-center.custom-train': '算法模型自定义训练',
  'menu.algorithm-center.custom-train-create': '新建训练',
  'menu.algorithm-center.custom-train-create-resume': '续训',
  'menu.algorithm-center.custom-train-annotate': '数据标注',
  'menu.open-legacy-settings': '开放平台参数',
  'menu.fee-center': '费用中心',
  'menu.fee-center.my-compute': '我的套餐',
  'menu.fee-center.my-compute.cloud': '云端套餐',
  'menu.fee-center.my-compute.local': '本地套餐',
  'menu.fee-center.quota-purchase': '额度购买',
  'menu.fee-center.quota-purchase.local': '本地版额度购买',
  'menu.fee-center.quota-purchase.cloud': '云端版额度购买',
  'menu.fee-center.balance-recharge': '余额与充值',
  'menu.fee-center.bill-center': '账单中心',
  // 兼容旧扁平 key（书签/外部引用兜底）
  'menu.monitor': '实时监控',
  'menu.warning-info': '预警信息',
  'menu.push-config': '推送配置',
  'menu.algorithm-market': '算法商城',
  'menu.my-algorithm': '我的算法',
  'menu.algo-self-train': '算法自训练',
  'menu.algo-self-train-review': '样本复核',
  'menu.custom-train': '算法模型自定义训练',
  'menu.custom-train-create': '新建训练',
  'menu.custom-train-annotate': '数据标注',
  'menu.quota-purchase': '额度购买',
  'menu.quota-purchase.local': '本地版额度购买',
  'menu.quota-purchase.cloud': '云端版额度购买',
  'menu.my-compute': '我的套餐',
  'menu.my-compute.cloud': '云端套餐',
  'menu.my-compute.local': '本地套餐',
  'menu.bill-center': '账单中心',
  'menu.balance-recharge': '余额与充值',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
